import { render, staticRenderFns } from "./AlertSuccess.vue?vue&type=template&id=6062798e&"
import script from "./AlertSuccess.vue?vue&type=script&lang=js&"
export * from "./AlertSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VAlert,VOverlay})
